import Vue from 'vue'
import Vuex from 'vuex'
import sha256 from 'js-sha256'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    language: 'de'
  },
  getters: {
    language: state => {
      return state.language
    }
  },
  mutations: {
  },
  actions: {
  }
})
export default store
